export const deliveryReport = {
	title: "Relatórios de Delivery",
	description: "Acompanhe e analise as entregas de delivery do seu estabelecimento.",
	tabs: {
		general: "Relatório geral",
	},
	selectPeriod: "Selecione um período",
	periodOptions: {
		today: "Hoje",
		last7days: "Últimos 7 dias",
		last15days: "Últimos 15 dias",
		last30days: "Últimos 30 dias",
		last90days: "Últimos 90 dias",
		custom: "Selecionar um período",
	},
	generalTab: {
		export: "Exportar",
		filtersToolbar: {
			search: "Buscar nº do pedido",
			vendors: "Plataforma",
			vendorsPlaceholder: "Selecionar plataforma",
			status: "Status",
			statusPlaceholder: "Selecionar status",
			period: "Período",
			periodPlaceholder: "Selecionar período",
			back: "Voltar",
			apply: "Aplicar",
		},
		table: {
			columns: {
				vendor: "Plataforma",
				reference: "Pedido Nº",
				status: "Status",
				date: "Data",
				orderCreatedAt: "Hora do Pedido",
				orderEndAt: "Pedido Finalizado",
				value: "Total",
				viewMore: "Ver Mais",
			},
			summary: "Total do período",
			seeMore: "Ver mais detalhes",
		},
		vendorType: {
			rappi: "Rappi",
			coala: "Coala",
			ifood: "iFood",
			keeta: "Keeta",
		},
		orderStatus: {
			cancelled: "Cancelado",
			concluded: "Concluído",
			confirmed: "Confirmado",
		},
		orderDetailsDrawer: {
			orderRangeWithEnd:
				"Pedido realizado em {{startDate}} às {{startHour}}<br>Finalizado às {{endHour}}",
			orderRangeWithoutEnd: "Pedido realizado em {{startDate}} às {{startHour}}",
			order: "Pedido",
			paymentDetails: "DETALHAMENTO FINANCEIRO",
			paymentMethod: "Forma de pagamento",
			subTotal: "Subtotal da venda",
			discountAndImpost: "Taxas e descontos",
			totalReceive: "Total a receber",
			discountValue: "-{{value}} - Cupom de desconto",
			discountValueDeliveryFee: "-{{value}} - Desconto na taxa de entrega",
			discountValueDeliveryFeeMarketplace:
				"-{{value}} - Desconto na taxa de entrega do {{marketplace}}",
			discountValueMarketplace: "-{{value}} - Desconto do {{marketplace}}",
			deliveryFee: "{{value}} - Taxa de Entrega",
			fees: "{{value}} - Taxas",
			feesTooltip: "Inclui taxa de pedido mínimo e taxa de serviço",
			paymentMethodType: {
				creditCardInPlace: "Cartão de crédito",
				creditCardOnline: "Cartão de crédito",
				debitCardOnline: "Cartão de débito",
				debitCardInPlace: "Cartão de débito",
				cash: "Dinheiro",
				voucherInPlace: "Voucher",
				ame: "Ame",
				pix: "Pix",
			},
		},
	},
	orderItemsTable: {
		columns: {
			count: "Qtd.",
			name: "Item",
			baseUnitPrice: "V. Unitário",
			totalUnitPrice: "Subtotal",
		},
		summary: "Subtotal",
		totalReceive: "TOTAL A RECEBER",
	},
	orderStatus: {
		ready: "Pronto",
		canceled: "Cancelado",
		concluded: "Concluído",
		confirmed: "Confirmado",
		dispatched: "Despachado",
		integrated: "Integrado",
		placed: "Criado",
		pendingPayment: "Pagamento pendente",
		pickupAreAssigned: "Cliente no local",
		scheduled: "Agendado",
	},
};
